module.exports = __webpack_public_path__ + "img/speaker2.png?13a2dc97cb96b832aa8a117f25836218";